export const insertThumbnailInUrl = (url: string): string => {
  const urlParts = url.split("/");
  const lastPartIndex = urlParts.length - 1;
  if (lastPartIndex >= 0)
    urlParts[lastPartIndex] = "ommuseThumb-" + urlParts[lastPartIndex];
  return urlParts.join("/");
};

export async function checkThumbnailUrl(url: string): Promise<boolean> {
  const http = new XMLHttpRequest();

  return new Promise((resolve, reject) => {
    http.open("HEAD", url);
    http.onreadystatechange = function () {
      if (this.readyState === this.DONE) {
        resolve(this.status < 400); // Resolve with true if status is less than 400
      }
    };
    http.onerror = function () {
      reject(new Error("Network error")); // Reject in case of a network error
    };
    http.send();
  });
}

export const getThumbnailUrl = async (imageUrl: string): Promise<string> => {
  try {
    const thumbnailUrl = insertThumbnailInUrl(imageUrl);
    const isUrlAccessible = await checkThumbnailUrl(thumbnailUrl);
    return isUrlAccessible ? thumbnailUrl : imageUrl;
  } catch (error) {
    console.error("Error checking image URL:", error);
    return imageUrl;
  }
};
